export enum NodeDeviceBus {
  PCIE = 1,
  USB = 2,
}

export enum NodeDeviceMeta {
  MODEL = "nodedevice",
  PK = "id",
}
